import * as angular from "angular";

angular
  .module('bringoz.admin.agent-inventory')
  .config(agentInventoryConfig);

/* @ngInject */
function agentInventoryConfig($stateProvider) {

  $stateProvider

    // Agent Inventory
    .state('agent-inventory', {
      parent: 'bringoz.site',
      url: '/agent-inventory',
      template: '<inventory-transactions></inventory-transactions>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Agent Inventory"});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    })

    .state('agent-inventory-settings', {
      parent: 'bringoz.site',
      url: '/agent-inventory/settings',
      template: '<inventory-settings></inventory-settings>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Inventory Settings"});
        triBreadcrumbsService.addCrumb({name: 'Agent Inventory'});
        triBreadcrumbsService.addCrumb({name: 'Resources'});
      }
    });

}
